import FJMobileTextToImageEdit from './FJMobileTextToImageEdit';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { useMemo } from 'react';
import FJTextToImageDataConfig from '../../../config/dataConfig/FJTextToImageDataConfig';
import FJActionTextToImage from '../../../redux/action/FJActionTextToImage';

const FJMobileTextToImageEditContainer = () => {
    useLocalStore();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const dispatch = useDispatch();

    const curModel = useSelector(state => state.textToImage.curModel);
    const generateNumber = useSelector(state => state.textToImage.generateNumber);
    const useCredit = useMemo(() => {
        const modelUseCredit = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.useCredit;
        const useCredit = modelUseCredit * generateNumber;

        return useCredit;
    }, [curModel, generateNumber]);
    const generate = () => {
        dispatch(FJActionTextToImage.generateAction());
    };
    return (
        <FJMobileTextToImageEdit
            generate={generate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            useCredit={useCredit}
            creditNumber={creditNumber}
        />
    );
};
export default FJMobileTextToImageEditContainer;
